import { UserLicenseField } from '@work4all/components/lib/components/entity-preview/user-preview/components/UserLicenseField';

import { FullUser } from '@work4all/models/lib/Classes/FullUser.entity';

import { ControllerPlus } from '../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../form-plus/use-form-context-plus';
import { Panel } from '../../../../components';
import { UserFormValue } from '../../types';

export const LicenseTabPanel = () => {
  const { watch, setValue, control } = useFormContextPlus<UserFormValue>();

  const user = watch();

  return (
    <Panel style={{ height: '100%' }}>
      <ControllerPlus
        control={control}
        name="assignedLicenses"
        render={({ fieldState }) => (
          <UserLicenseField
            value={user}
            error={fieldState.error?.message}
            onChange={(value) => {
              const localUserAssignedLicenses = user.assignedLicenses || [];
              localUserAssignedLicenses.forEach((x) => {
                if (x.license === value.license) {
                  x.assigned = value.assigned;
                  x.inUse = value.inUse;
                }
              });
              setValue('assignedLicenses', localUserAssignedLicenses, {
                shouldDirty: true,
              });
            }}
            onUserChange={(change) => {
              Object.entries(change).forEach(
                ([prop, value]: [keyof FullUser, FullUser[keyof FullUser]]) => {
                  setValue(prop, value, {
                    shouldDirty: true,
                  });
                }
              );
            }}
          />
        )}
      />
    </Panel>
  );
};
